export interface MaintenanceInfo {
  state: MaintenanceInfoActiveState,
  text: string,
  fromDate: string,
  toDate: string
}

export enum MaintenanceInfoActiveState {
  ACTIVE = 'immediately_active',
  INACTIVE = 'not_active',
  ACTIVE_FROM = 'from_date',
  ACTIVE_FROM_TO = 'active_from_to'
}
